import { Box, Container, Typography } from '@mui/material';

// Contenedor común para cada sección del portafolio (ancla + título + contenido)
export default function Section({ id, eyebrow, title, children, muted = false }) {
    return (
        <Box component="section" id={id} sx={{ py: { xs: 8, md: 11 }, bgcolor: muted ? '#f8fafc' : 'background.default' }}>
            <Container maxWidth="lg">
                <Typography variant="overline" color="primary" sx={{ fontWeight: 700, letterSpacing: '0.12em' }}>
                    {eyebrow}
                </Typography>
                <Typography variant="h2" sx={{ fontSize: { xs: '1.9rem', md: '2.5rem' }, mb: { xs: 4, md: 6 } }}>
                    {title}
                </Typography>
                {children}
            </Container>
        </Box>
    );
}
